export const TEACHER_COURSE_SEPARATOR = ",";

export function normalizeTeacherCourses(courses) {
  const normalized = [];
  const seen = new Set();

  for (const course of courses || []) {
    const courseName = String(course == null ? "" : course).trim();
    if (!courseName || seen.has(courseName)) {
      continue;
    }

    seen.add(courseName);
    normalized.push(courseName);
  }

  return normalized;
}

export function splitTeacherCourses(coursesStr, courseOptions = []) {
  if (!coursesStr) {
    return [];
  }
  if (Array.isArray(coursesStr)) {
    return normalizeTeacherCourses(coursesStr);
  }

  const normalizedCoursesStr = String(coursesStr).trim();
  if (!normalizedCoursesStr) {
    return [];
  }

  if (normalizedCoursesStr.startsWith("[")) {
    try {
      const parsed = JSON.parse(normalizedCoursesStr);
      if (Array.isArray(parsed)) {
        return normalizeTeacherCourses(parsed);
      }
    } catch (error) {
      // Continue with legacy parsers.
    }
  }

  if (normalizedCoursesStr.includes(TEACHER_COURSE_SEPARATOR)) {
    return normalizeTeacherCourses(
      normalizedCoursesStr.split(TEACHER_COURSE_SEPARATOR)
    );
  }

  const legacyParts = normalizedCoursesStr.split("/").filter(Boolean);
  if (!courseOptions.length || legacyParts.length <= 1) {
    return normalizeTeacherCourses(legacyParts);
  }

  const courseSet = new Set(courseOptions);
  const memo = new Map();
  function parseFrom(index) {
    if (index === legacyParts.length) {
      return [];
    }
    if (memo.has(index)) {
      return memo.get(index);
    }

    for (let end = legacyParts.length; end > index; end--) {
      const candidate = legacyParts.slice(index, end).join("/");
      if (!courseSet.has(candidate)) {
        continue;
      }
      const rest = parseFrom(end);
      if (rest) {
        const parsed = [candidate, ...rest];
        memo.set(index, parsed);
        return parsed;
      }
    }

    memo.set(index, null);
    return null;
  }

  return normalizeTeacherCourses(parseFrom(0) || legacyParts);
}

export function joinTeacherCourses(courses) {
  return normalizeTeacherCourses(courses).join(TEACHER_COURSE_SEPARATOR);
}
